import Vue from "vue";
import Router from "vue-router";
import * as cache from "@/utils/cache";
import Login from "@/pages/login/login";
import Index from "@/pages/layout/v2/espIndex";
import Home from "@/pages/index/home";
import Remote from "@/pages/tcode/remote/remote";
import Room from "@/pages/tcode/remote/room";
import VideoPlay from "@/pages/tcode/videoPlay/videoPlayMain";
import MyProfile from "@/pages/tcode/myProfile/profile";
import CustomMotions from "@/pages/tcode/motions/motions";
import SearchFun  from "@/pages/tcode/searchFun/searchFun";
import UserGuide  from "@/pages/tcode/userGuide/guide";
import Softwares  from "@/pages/tcode/softwares/softwares";
import OurProducts  from "@/pages/tcode/ourProducts/ourProducts";
import Terms  from "@/pages/tcode/terms/terms";
import Privacy  from "@/pages/tcode/privacy/privacy";
import BecomeMember  from "@/pages/tcode/member/becomeMember";
import PreMember  from "@/pages/tcode/member/preMember";
import Subscriptions  from "@/pages/tcode/subscriptions/index";

import Youtubeplayer from "@/pages/youtube/YouTubePlayer";

// Progress 进度条
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(Router)

let rout = [
  {
    path: '',
    redirect: '/login',
    meta: {title: '登录', keepAlive: false}
  },

  {
    path: "/login",
    name: "login",
    meta: {title: "登录"},
    component: Login
  },

  {
    path: '/youtubeplayer',
    name: "youtubeplayer",
    component: Youtubeplayer,
    meta: {title: 'youtubeplayer', keepAlive: false}
  },

  {
    path: '/ytfunplayer',
    name: "ytfunplayer",
    component: Youtubeplayer,
    meta: {title: 'ytfunplayer', keepAlive: false}
  },

  {
    path: '/espindex',
    component: Index,
    hidden: false,
    redirect: '/home',
    meta: { title: '一级菜单', icon: 'Folder'},
    name: 'index',
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/remote',
        name: 'remote',
        component: Remote,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/room',
        name: 'room',
        component: Room,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/videoPlay',
        name: 'videoPlay',
        component: VideoPlay,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/motions',
        name: 'motions',
        component: CustomMotions,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/searchFun',
        name: 'searchFun',
        component: SearchFun,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/guide',
        name: 'guide',
        component: UserGuide,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/softwares',
        name: 'softwares',
        component: Softwares,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/products',
        name: 'products',
        component: OurProducts,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/profile',
        name: 'profile',
        component: MyProfile,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/privacy',
        name: 'privacy',
        component: Privacy,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/terms',
        name: 'terms',
        component: Terms,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/becomeMember',
        name: 'becomeMember',
        component: BecomeMember,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/preMember',
        name: 'preMember',
        component: PreMember,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/subscriptions',
        name: 'subscriptions',
        component: Subscriptions,
        hidden: false,
        meta: { requiresAuth: true }
      },
      {
        path: '/SPort',
        name: 'SPort',
        level: 2,
        index: '1-4',
        component: () => import("@/pages/test/sport"),
        hidden: false,
        requiresAuth: false
      },
      {
        path: '/SVideo',
        name: 'SVideo',
        level: 2,
        index: '1-4',
        component: () => import("@/pages/test/video"),
        hidden: false,
        requiresAuth: false
      },
      {
        path: '/MotionProfile',
        name: 'MotionProfile',
        level: 2,
        index: '1-4',
        component: () => import("@/pages/test/MotionProfile"),
        hidden: false,
        requiresAuth: false
      }
    ]
  },
  {
    path: "/accountActivation/:pk",
    name: "accountActivation",
    meta: {title: "アカウントの有効化", keepAlive: true},
    component: () => import("@/pages/tcode/user/accountActivation")
  },

  {
    path: "/ssoLogin",
    name: "ssoLogin",
    component: () => import("@/pages/ssoLogin"),
    meta: {title: "功能跳转"}
  },

]

const router = new Router({routes: rout});

/**
 * 前端路由，权限控制
 * 1. 没有token直接去登录
 * 2. 有token，再看有没有本地数据，如果没有就刷新
 * 3. 控制前端白名单
 */
const whiteList = ["/login","/pctcode",'/youtubeplayer','/ytfunplayer']
router.beforeEach((to, from, next) => {
  NProgress.start();
  var token = cache.getToken();

  // 跳过 /accountActivation 路由的 token 校验
  if (to.name === "accountActivation") {
    next();
    return; // 直接跳过后续逻辑，继续访问该路由
  }
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // 1. 不需要认证的路由直接放行
  if (!requiresAuth) {
    next();
    return;
  }

  // 2. 需要认证的路由
  if (token) {
    // 用户已登录，放行
    next();
  } else {
    // 用户未登录，重定向到登录页
    if (whiteList.includes(to.path)) {
      next();
    } else {
      next("/login"); // 或者你的登录页路径
    }
  }
})
//跳转后，关闭加载
router.afterEach(() => {
  NProgress.done();
})

//解决点击同一个连接报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js